<ws-modal-wrapper headerLabel="Save Action View" (save)="save()" (cancel)="cancel()">
    @if (params.hasEditPermission) {
        <div class="mb-4 row">
            <span class="col-md-2 control-label">Type:</span>
            <div class="col-md-10">
                <label class="me-4">
                    <input
                        type="radio"
                        name="action-view-save-type"
                        [value]="categoryTypes.CUSTOM"
                        [checked]="actionViewType === categoryTypes.CUSTOM"
                        (change)="typeChanged(categoryTypes.CUSTOM)"
                    />
                    User Action View
                </label>
                <label>
                    <input
                        type="radio"
                        name="action-view-save-type"
                        [value]="categoryTypes.SYSTEM"
                        [checked]="actionViewType === categoryTypes.SYSTEM"
                        (change)="typeChanged(categoryTypes.SYSTEM)"
                    />
                    System Action View
                </label>
            </div>
        </div>
    }

    <div class="mb-4 row">
        <span class="col-md-2 control-label">Display Type:</span>
        <div class="col-md-10">
            <label class="me-4">
                <input
                    type="radio"
                    name="action-view-display"
                    [(ngModel)]="selectedDisplayType"
                    [value]="displayTypes.FILTER"
                />
                Filter
            </label>
            <label class="me-4">
                <input
                    type="radio"
                    name="action-view-display"
                    [(ngModel)]="selectedDisplayType"
                    [value]="displayTypes.OVERVIEW"
                    [disabled]="completed"
                />
                Overview
            </label>
            <label>
                <input
                    type="radio"
                    name="action-view-display"
                    [(ngModel)]="selectedDisplayType"
                    [value]="displayTypes.DETAILED"
                />
                Detailed List
            </label>
        </div>
    </div>

    <div class="mb-4 row">
        <label for="action-view-save-category" class="col-md-2 control-label">Category:</label>
        <div class="col-md-10">
            <select id="action-view-save-category" class="form-select form-select-sm" [(ngModel)]="selectedCategoryId">
                @for (category of filteredCategories; track category.categoryId) {
                    <option [ngValue]="category.categoryId">{{ category.categoryName }}</option>
                }
                @if (selectedCategoryId === 'new') {
                    <option value="new">{{ newCategoryName }}</option>
                }
            </select>
            <div class="input-group mt-2">
                <input
                    type="text"
                    class="form-control"
                    placeholder="New category"
                    maxlength="50"
                    [(ngModel)]="newCategoryName"
                    (keydown.enter)="$event.preventDefault(); createNewCategory()"
                />
                <button type="button" class="ace-btn btn-secondary" (click)="createNewCategory()">New</button>
            </div>
        </div>
    </div>

    <div class="mb-4 row">
        <label for="action-view-save-name" class="col-md-2 control-label">Name:</label>
        <div class="col-md-10">
            <input
                id="action-view-save-name"
                type="text"
                class="form-control"
                maxlength="50"
                required
                [(ngModel)]="actionViewName"
            />
        </div>
    </div>
</ws-modal-wrapper>
